import React, { Component } from 'react';
import { connect } from 'react-redux';
import DataTableHeader from '../components/DatatableHeaders/DataTableHeader';
import ModalAggregate from '../components/modals/ModalAggregate';
import MultidropdownHeader from '../components/DatatableHeaders/MultidropdownHeader';
import LayerHelper from '../util/LayerHelper';
import { createLayerFromColumn, addInlineLayer } from '../actions';
import css from '../css/module/new-world.css';

class DataTableHeaders extends Component {
  render() {
    const { rowIndex, headings, hasOptions } = this.props;
    const {
      layers,
      selectedLayerId,
      onCreateLayerFromColumn,
      tovByAlias,
      dbType,
      collapsedLayerId,
      isFixedHeader,
    } = this.props;
    const layerHelper = new LayerHelper(
      layers,
      selectedLayerId,
      collapsedLayerId,
    );
    const relevantLayers = layerHelper.enabledLayers();
    const headers = headings.map((h, index) =>
      hasOptions ? (
        <MultidropdownHeader
          key={index}
          heading={h}
          tov={tovByAlias[h.columnName().alias()]}
          optionClicked={onCreateLayerFromColumn(relevantLayers)}
          dbType={dbType}
          showOnboarding={isFixedHeader && index === 1}
        />
      ) : (
        <DataTableHeader
          key={index}
          heading={h}
          tovByAlias={tovByAlias}
          optionClicked={onCreateLayerFromColumn(relevantLayers)}
          dbType={dbType}
          popover={index === 2}
        />
      ),
    );
    const key = `header${rowIndex}`;
    return (
      <tr key={key} className="thead">
        <td key="expand" className={`no-border ${css.topLeftCell}`} />
        {headers}
        <td key="right-padding" className="no-border" />
      </tr>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layers: state.layers.all, // the layers of the query
    selectedLayerId: state.layers.selectedLayerId,
    tovByAlias: state.layers.usedAliases,
    dbType: state.datasource.dbType,
    collapsedLayerId: state.layers.collapsedLayerId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateLayerFromColumn:
      (relevantLayers) => (modal, columnName, additionalOptions) => (e) => {
        e.preventDefault();
        if (modal === ModalAggregate) {
          dispatch(addInlineLayer(modal, columnName, additionalOptions));
        } else {
          dispatch(
            createLayerFromColumn(
              modal,
              relevantLayers,
              columnName,
              additionalOptions,
            ),
          );
        }
      },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataTableHeaders);
